import React from 'react';

const Urdu = () => {
  return (
    <div>
      Urdu
      Urdu
    </div>
  );
}

export default Urdu;
